import moment from 'moment';

export const CARD_DATE_FORMAT = 'M/D/YYYY';

export const formatCardDate = (value?: string): string => {
	if (!value) return '';
	const parsed = moment.parseZone(value, moment.ISO_8601, true);
	return parsed.isValid() ? parsed.format(CARD_DATE_FORMAT) : value;
};
